import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/RegisterNewUser', 'post'>;

type Params = {
  email: string;
  firstName: string;
  lastName: string;
  marketingConsent: boolean;
  companyName?: string | undefined;
  jobPosition?: string | undefined;
  phoneNumber?: string | undefined;
};

export const registerNewUserFactory = (apiClient: ApiClient) => {
  const registerNewUser = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    await apiClient['/api/RegisterNewUser'].post(requestBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        email: input.email,
        name: {
          firstName: input.firstName,
          lastName: input.lastName,
        },
        hasGivenMarketingConsent: input.marketingConsent,
        organizationName: input.companyName ?? null,
        organizationGuid: null,
        jobTitle: input.jobPosition ?? null,
        phone: input.phoneNumber ?? null,
      },
    };
  };

  return registerNewUser;
};
